import { styled, useMediaQuery, useTheme } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useQuotation from '../../../hooks/quotations/useQuotation';
import {
    CustomItem,
    QuotationAccordionProps,
} from '../../../models/quotations/Quotation';
import { CustomItemsWrapper } from '../shared/CustomItemsWrapper';
import { QuotationNextButton } from '../shared/QuotationNextButton';

const StyledContent = styled('div')(() => ({
    paddingBottom: '10px',
}));

export const QuotationCustomItems: React.FC<QuotationAccordionProps> = (
    props
) => {
    const { handleNext, index, quoteData, updateProducts } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.CUSTOM_ITEMS',
    });
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('md'));
    const quotation = useQuotation();
    const quoteItemsChanged = useRef<boolean>(false);
    const quoteItems = useRef<CustomItem[]>(
        quoteData
            ? quoteData.custom_items.map((item): CustomItem => {
                  return {
                      name: item.name,
                      net_price: item.net_price,
                      quantity: Number(item.quantity),
                      unit: item.unit,
                      tax: item.tax,
                      gross_price:
                          item.net_price * item.quantity * (item.tax / 100 + 1),
                  };
              })
            : []
    );

    const handleCustomItemsChange = (content: CustomItem[]) => {
        quoteItemsChanged.current = true;
        quoteItems.current = content;
    };

    const save = () => {
        if (quoteItemsChanged.current) {
            quotation
                .saveCustomItems(
                    quotation.removeEmptyLinesFromCustomItems(
                        quoteItems.current
                    ),
                    quoteData.id
                )
                .then((resp) => {
                    updateProducts();
                    handleNext(index, resp);
                });
        } else {
            handleNext(index);
        }
    };

    return (
        <>
            <StyledContent>{t('MESSAGE')}</StyledContent>
            <div>
                <CustomItemsWrapper
                    fieldsVariant="filled"
                    defaultCustomItems={quoteItems.current}
                    handleChange={handleCustomItemsChange}
                />
                <QuotationNextButton fullWidth={small} onClick={save} />
            </div>
        </>
    );
};
